//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import areaList from '../../assets/js/Area';

export default {
    name: "addressEdit",
    data() {
        return {
            areaList,
            id: 0,
            addressInfo: {},
            saving: false
        }
    },
    methods: {
        onSave(data) {
            var params = {
                id: data.id,
                contact: data.name,
                contactPhone: data.tel,
                areaName: data.province + data.city + data.county,
                areaId: data.areaCode,
                contactAddress: data.addressDetail,
                isDefault: data.isDefault,
            };

            if (localStorage.getItem('MemberId')) {
                params.memberId = parseInt(localStorage.getItem('MemberId'));
            } else {
                params.memberId = 0;
            }
            this.saving = true;
            abp.ajax.post('/api/services/app/ContactInformation/SaveContactInformation', params).then(res => {
                this.saving = false;
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            })
        },
        onDelete() {
            abp.ajax.delete('/api/services/app/ContactInformation/DeleteContactInformation?id=' + this.id).then(res => {
                this.$router.back();
            });
        },
        onChangeDetail() {
        },
        getAddress() {
            var vm = this;
            abp.ajax.get('/api/services/app/ContactInformation/GetContactInformationById?id=' + this.id).then(res => {
                vm.addressInfo = {};
                vm.addressInfo.id = res.data.result.id;
                vm.addressInfo.name = res.data.result.contact;
                vm.addressInfo.tel = res.data.result.contactPhone;
                vm.addressInfo.areaCode = res.data.result.areaId.toString();
                vm.addressInfo.addressDetail = res.data.result.contactAddress;
                vm.addressInfo.isDefault = res.data.result.isDefault;
                vm.addressInfo.postal_code = ''
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getAddress()
        }
    }
}
